import {Modal} from 'bootstrap'


document.addEventListener('alpine:init', () => {
  Alpine.data('home', () => ({
    // data and model
      name: '',
      email: '',
      message: '',
      background_id: window.defaultBackgrounImage,
      background: window.defaultBackgrounImage,
      loading: false,
      owner: '',
      link: '',
      locscreenError: '',
      showCustomId: false,
      custom_id: '',

      showLink: false,
      // res
      lockscreenUrl : '',

      oldRoutePath: '#/',
    
      backgroundId: window.backgroundId,

      // modal
      createLockScreenModal:  null,
      createdLockScreenModal: null,

      saveLockScreenModal: null,

      currentRoute: '',

      //@computed
      isFormCreateValid() {
        //return this.name?.length && this.email?.length && this.message?.length && this.owner?.length
        return this.name?.length && this.message?.length && this.owner?.length
      },

      isOs(type = 'windows') {
        switch(type) {
          case 'windows':
            return navigator.platform.includes('Win')
            break;
          case 'linux':
            return navigator.platform.includes('Linux')
            break;
          case 'mac':
            return  /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform)
            break;

        }
      },

      isAllFormValid() {
        return this.isFormCreateValid() && this.background_id
      },

      isActivePath(path, exact = true) {
        return this.currentRoute == path
      },

      //@method
      handleFormCreate() {
        if(this.isFormCreateValid()) {
          this.createLockscreen()
          // if(this.background?.length) {
          //   this.createLockscreen({})
          // } else {
          //   this.createLockScreenModal.show()
          // }
        }
      },

      async share(e, type = 'copy', text = '') {
        switch(type) {
          case 'facebook':
            window.open(`https://www.facebook.com/sharer/sharer.php?u=${window.location.href}&quote=${text}`, '_blank')
            break
          case 'twitter':
            window.open(`https://twitter.com/intent/tweet?url= ${text} ${window.location.href}`, '_blank')
            break
          case 'linkedin':
              window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(window.location.href)}`, '_blank')
              break
          case 'email':
              window.open(`mailto:?body=${text} "${window.location.href}`, '_blank')
              break
          default:
            const element = e.currentTarget
            await navigator.clipboard.writeText(`${text} ${window.location.href}`)
            element.querySelector('.copy').classList.add('d-none')
            element.querySelector('.coppied').classList.remove('d-none')
            setTimeout(() => {
              element.querySelector('.copy').classList.remove('d-none')
              element.querySelector('.coppied').classList.add('d-none')
            }, 2000)
        }
      },
      createLockscreen(e) {
        
        // if (!this.isAllFormValid()) return false

        e?.preventDefault?.()
        e?.stopPropagation?.()
        this.lockscreenUrl = ''
        this.loading = true
        this.locscreenError = ''

        const date = new Date()

        const form = {
          email: this.email,
          name: this.name,
          message: this.message,
          owner: this.owner,
          background_id: this.background_id,
          created_at: `${date.getFullYear()}-${date.getMonth()}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
        }


        if(this.showLink) {
          form.link = this.link
        }

        axios.post('/lock-screen', form).then(({data}) => {
          window.location.href = data.data.url
          this.lockscreenUrl = data.data.url
          // this.createdLockScreenModal.show()

          this.background = window.defaultBackgrounImage
          this.name = ''
          this.message = ''
          this.email = ''
          this.owner = ''
          this.link = ''
        }).catch(err => {
          this.lockscreenUrl = ''
          this.locscreenError = 'Failed create lockscreen, Please contact the administrator'
          // new Modal(document.getElementById('result-error')).show()
        })
        .then(() => {
          this.loading = false
          this.$refs.imageList.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          })
          this.$refs.overlayBody.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          })
        })
      },
      async copyLockscreen(e) {
        await navigator.clipboard.writeText(this.lockscreenUrl)
        e.target.textContent = 'Coppied !'
        setTimeout(() => {
          e.target.textContent = 'Copy Link'
        }, 2500)
      },
      async copyCurrentLink(e) {
        await navigator.clipboard.writeText(window.location.href)
        e.target.textContent = 'Coppied !'
        setTimeout(() => {
          e.target.textContent = 'Copy Link'
        }, 2500)
      },

      saveLockScreen(e) {

        e.preventDefault()
        e.stopPropagation()
        this.loading = true

        const form = {
          backgroundId: this.backgroundId
        }

        axios.post('/lock-screen/save', form).then(({data}) => {
          new Modal(document.getElementById('result-lockscreen')).show()
          this.backgroundId = ''
          this.background = data.data.url
          document.querySelector('#lockscreen-background').setAttribute('src', data.data.background)
          document.querySelectorAll('#lockscreen-text').forEach(el => el.textContent =  data.data.message)
        }).catch(err => {
          console.log(err)
          this.backgroundId = ''
          new Modal(document.getElementById('result-error')).show()
        })
        .then(() => {
          this.saveLockScreenModal.hide()
          this.loading = false
        })
      },      

      handlePatchChange() {
        const path = window.location.hash.replaceAll('#/', '')
        this.currentRoute = path || ''

        document.querySelector('#navbar-header').classList.remove('show')

      },

      // init
      init() {

        window.addEventListener('locationchange', ()=> {
          this.handlePatchChange()
        });

        // init when load
        this.handlePatchChange()

        // init default url opened

        if(this.currentRoute?.length == 0) {
          if(window.defaultUrl) {
            window.location.hash = window.defaultUrl
          }
        }

        this.$watch('currentRoute', (_, oldRoutePath) => {
          if(oldRoutePath?.length) {
            this.oldRoutePath = `#/${oldRoutePath}`
          }
        })
          
      }


  }))
})
